export const ADD_ITEM_BUTTON_TEXT = 'Add Item';
